<script>
    import { preventDefault } from 'svelte/legacy';
    import vulnerabilityService from "../service.js";
    import assetService from "../../asset/service.js";
    import customService from "./v2-service.js";
    import BreadCrumNav from "../../../components/breadcrum-nav.svelte";
    import Form from './_form.svelte';
    import FindingForm from '../../finding/_form.svelte';
    import userService from '../../user/service.svelte.js';
    import SummaryForm from '../../_summary/_form.svelte';
    import summaryService from '../../_summary/service.js';
    import documentService from '../../../services/document.js';
    import AssetsApi from '../../asset/assets.api.js';
    import { onMount, onDestroy, tick } from 'svelte';
    import { notificate } from '../../../services/notification';
    import V2List from '../_components/v2-list.svelte';
    import powerTableService from '../../../services/powerTable.js';
    import tagService from '../../tag/service.js';
    import VulnerabilityTitleRow from '../../../components/powerTable/vulnerability-title-row.svelte';
    import { format } from 'svelte-i18n';
    import Spinner from "../../../components/spinner.svelte";
    import { CVSS } from "@turingpointde/cvss.js";
    import { Modal } from "bootstrap";
    import * as bootstrap from "bootstrap";

    let hiddenColumns           = $state([4,5]);
    let asset_id                = $state(null);
    let errors                  = $state([]);
    let files_uploaded          = $state([]);
    let files_uploading         = $state(false);
    let show_finish_btn         = $state(false);
    let vulnerabilitiesFiltered = [];
    let vuls                    = [];
    let files                   = $state([]);
    let summaries               = $state([]);
    let vdb_update_errors       = $state([]);
    let vdb_update_success      = $state(null);
    let forceUpdateVDB          = false;
    let assets                  = $state([]);
    let forcePublicIpsAsPrivate = $state(false);
    let vrf                     = $state();
    let vrfError                = $state(false);
    let loadingHTML;
    let updatingVDB             = $state();
    let uploadingVRF;
    let showUploadButton        = false;
    let tabActive               = $state("add");
    let loggedUserPromise       = userService.getLoggedUser();

    // Unconditionally removes all backdrop nodes and resets body styles
    const purgeBackdrops = () => {
        document.querySelectorAll('.modal-backdrop').forEach((b) => b.remove());
        document.body.classList.remove("modal-open");
        document.body.style.removeProperty("padding-right");
        document.body.style.removeProperty("overflow");
    };

    const getModalInstance = (elementId) => {
        const el = document.getElementById(elementId);
        if (!el) return null;
        try {
            if (typeof Modal !== "undefined" && Modal.getOrCreateInstance) {
                return Modal.getOrCreateInstance(el);
            }
        } catch (e) {
            console.warn(e);
        }
        const bs = typeof bootstrap !== "undefined" ? bootstrap : window.bootstrap;
        const ModalClass = bs?.Modal || bs?.default?.Modal || window?.bootstrap?.Modal;
        if (ModalClass) {
            return ModalClass.getOrCreateInstance ? ModalClass.getOrCreateInstance(el) : new ModalClass(el);
        }
        return null;
    };

    const openModal = (id) => {
        purgeBackdrops();
        const inst = getModalInstance(id);
        if (inst) {
            inst.show();
        } else {
            const el = document.getElementById(id);
            if (el) {
                el.classList.add("show");
                el.style.display = "block";
                el.removeAttribute("aria-hidden");
                el.setAttribute("aria-modal", "true");

                if (!document.querySelector(".modal-backdrop")) {
                    const backdrop = document.createElement("div");
                    backdrop.className = "modal-backdrop fade show";
                    document.body.appendChild(backdrop);
                }
                document.body.classList.add("modal-open");
            }
        }
    };

    const closeModal = (id) => {
        const el = document.getElementById(id);
        if (el) {
            el.classList.remove("show");
            el.style.display = "none";
            el.setAttribute("aria-hidden", "true");
            el.removeAttribute("aria-modal");
        }

        try {
            const inst = getModalInstance(id);
            if (inst) {
                inst.hide();
            }
        } catch (err) {
            console.warn("Bootstrap JS hide error:", err);
        }

        purgeBackdrops();
        setTimeout(purgeBackdrops, 100);
        setTimeout(purgeBackdrops, 350);
    };

    let customVulnerabilitiesPromise  = $state(customService.search()
        .then(async pVuls =>{
            let assetsPromise = assetService.search("v2/asset/", { filter: {in_scope: true} });
            assets = await assetsPromise;

            vuls = pVuls;
            tags = await getTags();
            let tagAssociations = await getTagAssociations();
            for(let vul of vuls){
                if(tags.length > 0){
                    vul.tag = [];
                    for(let tag of tags){
                        for(let link of tagAssociations){
                            if(tag.id === link.tag_id && vul.id === link.target_object_id){
                                vul.tag.push(tag);
                            }
                        }
                    }
                    vul.tag = vul.tag.sort((a,b) => a.name.localeCompare(b.name));
                }
            }
            return vuls;
        }));

    let vulnerabilitiesPromise  = vulnerabilityService.search("v2/vulnerability", {})
        .then(async pVuls =>{
            let customVuls = await customService.search();
            pVuls = pVuls.filter(vul => !vul.id.includes("X-"));
            pVuls = [...pVuls, ...customVuls];
            pVuls = pVuls.sort((a,b)=>{
                if(!a.title) a.title = a.id;
                if(!a.title_es) a.title_es = a.title;
                if(!b.title) b.title = b.id;
                if(!b.title_es) b.title_es = b.title;
                return a.title_es.localeCompare(b.title_es);
            });
            return pVuls;
        });

    let summariesPromise = summaryService.search().then(pSummaries => summaries = pSummaries);
    let tags  = $state([]);

    let ptOptions = {
        uniquePrefix: 'customVulnerabilityTable',
        rowsPerPageOptions: [10, 20, 50, 100],
        footerText: false,
        footerFilters: false,
        footerLoadingBar: false,
        segments: {
            'topBar': ['search'],
            'pTable': ['table'],
            'bottomBar': ['dropdown', 'stats', 'pagination'],
        },
        translations: powerTableService.getTableTranslations(),
        isDataRemote: false,
    };

    let ptInstructs = [
        {key: 'select', title: "", filterable: false, sortable: false},
        {key: 'priority', title: $format("list.columns.priority"), filterable: false, parseAs: 'unsafe-html', userFunctions: {customSort: powerTableService.sortNumbers}},
        {key: 'title_es', title: $format("list.columns.title"), filterable: false, parseAs: 'component', dataComponent: VulnerabilityTitleRow },
        {key: 'open', title: $format("list.columns.open"), filterable: false, userFunctions: {customSort: powerTableService.sortNumbers}},
        {key: 'accepted', title: $format("list.columns.accepted"), filterable: false, userFunctions: {customSort: powerTableService.sortNumbers}},
        {key: 'fixed', title: $format("list.columns.fixed"), filterable: false, userFunctions: {customSort: powerTableService.sortNumbers}},
        {key: 'false_positive', title: $format("list.columns.false_positive"), filterable: false, userFunctions: {customSort: powerTableService.sortNumbers}},
        {key: 'cvss', title: 'CVSS', filterable: false, userFunctions: {customSort: powerTableService.sortNumbers}},
        {key: 'epss', title: 'EPSS', filterable: false, userFunctions: {customSort: powerTableService.sortNumbers}},
        {key: 'tag', title: $format("list.columns.tag"), filterable: false, parseAs: 'unsafe-html'}
    ];

    const columnsChange = () => {
        if(!hiddenColumns.length){
            hiddenColumns = [4,5];
        }
        else {
            hiddenColumns = [];
        }
    };

    const getTags = async(config= {filter: {}}) => {
        let tags = await tagService.search('v2/tag/', config);
        return tags;
    };

    const getTagAssociations = async(config = {filter: {target_object_type: "Vulnerability"}}) => {
        let tagAssociations = await tagService.search('v2/tag/association/', config);
        return tagAssociations;
    };

    const handleTableRefresh = async () => {
        customVulnerabilitiesPromise  = customService.search({forceRefresh: true})
            .then(async pVuls =>{
                vuls = pVuls;
                tags = await getTags();
                let tagAssociations = await getTagAssociations();
                for(let vul of vuls){
                    if(tags.length > 0){
                        vul.tag = [];
                        for(let tag of tags){
                            for(let link of tagAssociations){
                                if(tag.id === link.tag_id && vul.id === link.target_object_id){
                                    vul.tag.push(tag);
                                }
                            }
                        }
                        vul.tag = vul.tag.sort((a,b) => a.name.localeCompare(b.name));
                    }
                }
                return vuls;
            });

        vulnerabilitiesPromise  = vulnerabilityService.search("v2/vulnerability", {})
            .then(async pVuls =>{
                let customVuls = await customService.search();
                pVuls = pVuls.filter(vul => !vul.id.includes("X-"));
                pVuls = [...pVuls, ...customVuls];
                pVuls = pVuls.sort((a,b)=>{
                    if(!a.title) a.title = a.id;
                    if(!a.title_es) a.title_es = a.title;
                    if(!b.title) b.title = b.id;
                    if(!b.title_es) b.title_es = b.title;
                    return a.title_es.localeCompare(b.title_es);
                });
                return pVuls;
            });

        summariesPromise = summaryService.search().then(pSummaries => summaries = pSummaries);
        
        closeModal("summary-add-modal");
        closeModal("file-add-modal");
        closeModal("custom-add-modal");
        closeModal("finding-add-modal");
        closeModal("vrf-add-modal");
        closeModal("update-vdb-modal");
    };

    const handleAdd = () => {
        closeModal("custom-add-modal");
        closeModal("finding-add-modal");
        closeModal("summary-add-modal");
        handleTableRefresh();
    };

    const translateErrorMessages = (e) => {
        if(e && e.detail == 'Invalid document kind. Supported: Nmap XML, OpenVAS XML, PingCastle HTML'){
            return "Documento inválido. Archivos soportados: Nmap XML, OpenVAS XML, PingCastle HTML.";
        }
        else if(e && e.detail == 'Invalid document content') {
           return "Documento con contenido inválido.";
        }
        else {
            return '';
        }
    };

    const loadFile = (e) => {
        files = e.target.files;
        showUploadButton = true;
    };

    const cancelFileUpload = () => {
        files = [];
        errors = [];
        files_uploaded = [];
        showUploadButton = false;
        show_finish_btn = false;
        closeModal("file-add-modal");
    };

    const finishFileUpload = () => {
        files = [];
        errors = [];
        files_uploaded = [];
        showUploadButton = false;
        show_finish_btn = false;
        closeModal("file-add-modal");
    };

    const uploadFile = async() => {
        show_finish_btn = false;
        files_uploading = true;
        let data = {};

        if(asset_id){
            data.asset_id = asset_id;
        }

        data.force_private_ip = forcePublicIpsAsPrivate;

        let filesArray = Array.from(files);
        for(let file of filesArray){
            try {
                let response = await documentService.save(data, file);
                files_uploaded.push(file.name);
                files_uploaded = files_uploaded;
            }
            catch(e) {
                errors.push({
                    msg: translateErrorMessages(e),
                    fileName: file.name
                });
                errors = errors;
            }
        }

        showUploadButton = false;
        files_uploading = false;
        show_finish_btn = true;
    };

    const closeVRFmodal = () => {
        vrf = null;
        vrfError = false;
        closeModal("vrf-add-modal");
    };

    const uploadVRF = async () => {
        if(!vrf) return;
        let data = {};
        data = vrf;

        try {
            data = JSON.parse(data);
        }
        catch {
            return vrfError = true;
        }

        return customService.uploadVRF(data)
            .catch(errors => {
                return false;
            })
            .then(response =>{
                if(!response.ok){
                    notificate(`${response.status}`);
                }
                else {
                    closeVRFmodal();
                    notificate('uploadVRFOk', "toast", {data: ''});
                }
            });
    };

    const closeUpdateVDBmodal = () => {
        forceUpdateVDB     = null;
        vdb_update_errors  = [];
        vdb_update_success = null;
        closeModal("update-vdb-modal");
    };

    const updateFromVDB = async (e) => {
        if (e && typeof e.preventDefault === "function") e.preventDefault();
        updatingVDB = true;
        let config = {};
        return customService.updateFromVDB(config)
            .then(async response=>{
                if(response == "VDB updated")
                    notificate('updateVDBOk', "toast", {data: ''});
                vdb_update_success = response;
                updatingVDB = false;
            })
            .catch(error=>{
                vdb_update_errors.push(error);
                updatingVDB = false;
                return false;
            });
    };

    onMount(() => {
        const handleHidden = () => purgeBackdrops();
        document.addEventListener("hidden.bs.modal", handleHidden);

        return () => {
            document.removeEventListener("hidden.bs.modal", handleHidden);
        };
    });
</script>

<style>
    h4 small{
        font-size: 0.75rem;
        display: block;
    }
    .nav-item button.nav-link.active{
        color: inherit !important;
    }
</style>

<!-- MODAL -->
<div 
    class="modal fade" 
    id="custom-add-modal" 
    tabindex="-1" 
    aria-hidden="true"
>
    <div class="modal-dialog" style="max-width: 80%; width: 80%;">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">{$format("add")} {$format("custom_vul")} <div><small><span title="Requerido" class="text-danger">*</span>Requerido</small></div></h4>
                <button type="button" class="btn-close" aria-label="Close" onclick={() => closeModal("custom-add-modal")}></button>
            </div>
            <div class="modal-body">
                <Form config={{add: true}} onsave={handleAdd} oncancel={() => closeModal("custom-add-modal")} on:save={handleAdd} />
            </div>
        </div>
    </div>
</div>
<!-- END MODAL-->

<!-- FINDING MODAL -->
<div 
    class="modal fade" 
    id="finding-add-modal" 
    tabindex="-1" 
    aria-hidden="true"
>
    <div class="modal-dialog modal-xl">
        <div class="modal-content modal-xl">
            {#await vulnerabilitiesPromise then vulnerabilities}
                <div class="modal-header">
                    <h4 class="modal-title">{$format("add")} {$format("custom_finding")}</h4>
                    <button type="button" class="btn-close" aria-label="Close" onclick={() => closeModal("finding-add-modal")}></button>
                </div>
                <div class="modal-body">
                    <FindingForm custom_vuls={vulnerabilities} {assets} config={{add: true}} onsave={handleAdd} oncancel={() => closeModal("finding-add-modal")} on:save={handleAdd} />
                </div>
            {/await}
        </div>
    </div>
</div>
<!-- END FINDING MODAL-->

<!-- FILE MODAL -->
<div 
    class="modal fade" 
    id="file-add-modal" 
    tabindex="-1" 
    aria-hidden="true"
>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">{$format("buttons.add_file")}</h4>
                <button type="button" class="btn-close" aria-label="Close" onclick={() => closeModal("file-add-modal")}></button>
            </div>
            <div class="modal-body">
                {#if files.length}
                    {#each Array.from(files) as file}
                        <div><strong>{$format("buttons.file")}:</strong>{file.name}</div>
                    {/each}
                    <div class="mb-3 mt-3">
                        <label for="force-public-ips">{$format("page.vulnerability.force_public_private")}:</label>
                        <input
                            class=""
                            id="force-public-ips"
                            type="checkbox"
                            name="force-public-ips"
                            bind:checked={forcePublicIpsAsPrivate}
                        />
                    </div>
                    <div class="mb-3 mt-3">
                        {#await AssetsApi.fetchAssets('v2/asset/',{filter:{kind: 'cloud'}}) then clouds}
                        <label for="asset_id">{$format("asset.kind.cloud.singular")}:</label>
                        <select id="asset_id" bind:value={asset_id} style="max-width: 318px; margin-top: 1em;">
                            <option value="none">{$format("form.fields.select")}...</option>
                            {#each clouds as cloud}
                                <option value={cloud.id}>{cloud.name}</option>
                            {/each}
                        </select>
                        {/await}
                    </div>
                {:else}
                    <label for="fileInput" style="display: block; float: left; clear:both;">
                        <i class="fas fa-file-upload" style="cursor: pointer; font-size: 20px;" title="Seleccionar archivo">
                            <input id="fileInput" style="opacity: 0; width: 0;" oninput={(e)=> loadFile(e)} class="" type="file" multiple="multiple" />
                        </i>
                        <span style="font-weight: 400;">{$format("buttons.select_file")}</span>
                    </label>
                {/if}
                <div class="mt-3">
                    {#if show_finish_btn}
                        <button class="btn btn-primary" onclick={finishFileUpload}>Finalizar</button>
                    {:else}
                        {#if !files_uploading}
                            {#if files && files[0] && (!errors.length && !files_uploaded.length)}
                                <button class="btn btn-xs btn-success mt-1" title="Enviar archivo" onclick={uploadFile}>
                                    <span>Enviar</span>
                                    <i class="fas fa-check"></i>
                                </button>
                                <button class="btn btn-xs btn-danger mt-1 ms-1" title="Cancelar" onclick={cancelFileUpload}>
                                    <span>{$format("buttons.cancel")}</span>
                                    <i class="fas fa-times"></i>
                                </button>
                            {/if}
                        {:else}
                            <i class="fas fa-sync-alt fa-spin"></i>
                        {/if}
                    {/if}
                </div>
                {#if errors.length}
                    {#key errors}
                        {#each errors as error}
                            <div class="mt-3" style="color: white; padding: 7px; border-radius: 4px; background: #dc3545e0; width: fit-content">
                                <div>No pudo cargarse el archivo <strong>{error.fileName}</strong></div>
                                {#if error.msg}<div class="mt-1"><strong>Error</strong>: {error.msg}</div>{/if}
                            </div>
                        {/each}
                    {/key}
                {/if}
                {#if files_uploaded.length}
                    <div class="mt-3"><strong>Archivos cargados con éxito</strong>:</div>
                    {#key files_uploaded}
                        {#each files_uploaded as fileName}
                            <div class="" style="padding: 7px; border-radius: 4px; color: rgb(40, 167, 69);">
                                <div><strong>{fileName}</strong></div>
                            </div>
                        {/each}
                    {/key}
                {/if}
            </div>
        </div>
    </div>
</div>
<!-- END FILE MODAL-->

<!-- UPDATE FROM VDB MODAL -->
<div 
    class="modal fade" 
    id="update-vdb-modal" 
    tabindex="-1" 
    aria-hidden="true"
>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">{$format("buttons.update_vdb")}</h4>
                <button type="button" class="btn-close" aria-label="Close" onclick={closeUpdateVDBmodal}></button>
            </div>
            <div class="modal-body">
                <div class="mb-3 input-half ms-4">
                    <div>
                        {#if !updatingVDB}
                            <button id="updateVDBBtn" type="button" class="btn btn-primary mt-3" onclick={updateFromVDB}>Actualizar</button>
                            <button type="button" class="btn btn-default mt-3" onclick={closeUpdateVDBmodal}>{$format("buttons.cancel")}</button>
                        {:else}
                            <i class="fa-sync-alt fa-spin fas"></i>
                        {/if}
                        {#if vdb_update_success}
                            <div class="bg-success mt-3 ps-3 pe-3 pt-3 pb-3" style="border-radius: 4px;">
                                <div>Vulnerabilidades actualizadas con éxito</div>
                            </div>
                        {/if}
                        {#if vdb_update_errors.length > 0}
                            {#each vdb_update_errors as error}
                                <div class="bg-danger mt-3 ps-3 pe-3 pt-3 pb-3" style="border-radius: 4px;">
                                    <div><strong>Archivo</strong>: {error.file}</div>
                                    <div><strong>Error</strong>: {error.reason}</div>
                                </div>
                            {/each}
                        {/if}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- END UPDATE FROM VDB MODAL-->

<!-- VRF MODAL -->
<div 
    class="modal fade" 
    id="vrf-add-modal" 
    tabindex="-1" 
    aria-hidden="true"
>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">{$format("add")} VRF</h4>
                <button type="button" class="btn-close" aria-label="Close" onclick={closeVRFmodal}></button>
            </div>
            <div class="modal-body">
                <div class="mb-3">
                    <label for="customVulVRF">VRF</label>
                    <textarea
                        class="form-control"
                        id="customVulVRF"
                        name="vrf"
                        placeholder="VRF"
                        style="height: 350px;"
                        bind:value={vrf}
                    ></textarea>
                    {#if vrfError}
                        <div class="mt-3 alert alert-danger">No es un JSON válido.</div>
                    {/if}
                    <button id="customVulAddVRF" type="button" class="btn btn-primary mt-3" onclick={uploadVRF}>{$format("buttons.save")}</button>
                    <button type="button" class="btn btn-default mt-3" onclick={closeVRFmodal}>{$format("buttons.cancel")}</button>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- END VRF MODAL-->

<!-- SUMMARY MODAL -->
<div 
    class="modal fade" 
    id="summary-add-modal" 
    tabindex="-1" 
    aria-hidden="true"
>
    <div class="modal-dialog">
        <div class="modal-content" style="width: 1000px; left: -45%;">
            <div class="modal-header">
                <h4 class="modal-title">{$format("add")} Resumen</h4>
                <button type="button" class="btn-close" aria-label="Close" onclick={() => closeModal("summary-add-modal")}></button>
            </div>
            <div class="modal-body">
                <div class="card tabs">
                    <div class="card-header p-0 border-bottom-0">
                        <ul class="nav nav-tabs" id="custom-tabs-four-tab" role="tablist">
                            <li class="nav-item">
                                <button
                                    type="button"
                                    class="nav-link"
                                    class:active={tabActive === 'add'}
                                    onclick={() => tabActive = 'add'}
                                >
                                    {$format("buttons.add")}
                                </button>
                            </li>
                            <li class="nav-item">
                                <button
                                    type="button"
                                    class="nav-link"
                                    class:active={tabActive === 'edit'}
                                    onclick={() => tabActive = 'edit'}
                                >
                                    {$format("buttons.edit")}
                                </button>
                            </li>
                            <li class="nav-item">
                                <button
                                    type="button"
                                    class="nav-link"
                                    class:active={tabActive === 'delete'}
                                    onclick={() => tabActive = 'delete'}
                                >
                                    {$format("buttons.delete")}
                                </button>
                            </li>
                        </ul>
                    </div>
                    <div class="card-body">
                        <div class="tab-content" id="custom-tabs-four-tabContent">
                            <div 
                                class="tab-pane fade" 
                                class:active={tabActive === 'add'} 
                                class:show={tabActive === 'add'} 
                                id="custom-tabs-four-add" 
                                role="tabpanel"
                            >
                                <SummaryForm config={{add: true}} {summaries} onsave={handleAdd} oncancel={() => closeModal("summary-add-modal")} />
                            </div>
                            <div 
                                class="tab-pane fade" 
                                class:active={tabActive === 'edit'} 
                                class:show={tabActive === 'edit'} 
                                id="custom-tabs-four-edit" 
                                role="tabpanel"
                            >
                                <SummaryForm config={{edit: true}} {summaries} onsave={handleAdd} oncancel={() => closeModal("summary-add-modal")} />
                            </div>
                            <div 
                                class="tab-pane fade" 
                                class:active={tabActive === 'delete'} 
                                class:show={tabActive === 'delete'} 
                                id="custom-tabs-four-delete" 
                                role="tabpanel"
                            >
                                <SummaryForm config={{delete: true}} {summaries} ondelete={handleTableRefresh} oncancel={() => closeModal("summary-add-modal")} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- END SUMMARY MODAL-->

{#await loggedUserPromise then user}
    {#if user.email.includes('@securetia.com')}
        <section class="content-header">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-6">
                        <h1 class="mt-3 mb-3 page-title">
                            <i class="fas fa-user-secret fa-xs"></i>
                            Vulnerabilidades privadas
                        </h1>
                    </div>
                    <div class="col-6">
                        <BreadCrumNav routes={[{ label: $format("vuls") }]} />
                    </div>
                </div>
            </div>
        </section>
        <section class="content">
            <div class="container-fluid">
            </div>
        </section>
        <section class="content">
            <div class="container-fluid">
                <div class="row d-flex flex-row">
                    <div class="col-12">
                        <div class="card card-data" style="flex: 2 0 0;">
                            <div class="card-header">
                                <div class="card-title">
                                    Agregar
                                </div>
                            </div>
                            <div class="card-body">
                                {#await vulnerabilitiesPromise then data}
                                    <div>
                                        {#if !loadingHTML}
                                            <button class="btn btn-default mt-3" id="addCustomVulBtn" style="border-radius: 8px; height: 42px;" onclick={() => openModal("custom-add-modal")}>
                                                {$format("vuls")}
                                            </button>
                                        {:else}
                                            <i class="fa-sync-alt fa-spin fas"></i>
                                        {/if}
                                        {#if !loadingHTML}
                                            <button class="btn btn-default mt-3 ms-3" id="addCustomFindingBtn" style="border-radius: 8px; height: 42px;" onclick={() => openModal("finding-add-modal")}>
                                                {$format("finding.word")}
                                            </button>
                                        {:else}
                                            <i class="fa-sync-alt fa-spin fas"></i>
                                        {/if}
                                        {#if !loadingHTML}
                                            <button class="btn btn-default mt-3 ms-3" style="border-radius: 8px; height: 42px;" onclick={() => openModal("file-add-modal")}>
                                                {$format("buttons.file")}
                                            </button>
                                        {:else}
                                            <i class="fa-sync-alt fa-spin fas"></i>
                                        {/if}
                                        {#if !loadingHTML}
                                            <button class="btn btn-default mt-3 ms-3" id="addSummaryBtn" style="border-radius: 8px; height: 42px;" onclick={() => openModal("summary-add-modal")}>
                                                {$format("summary")}
                                            </button>
                                        {:else}
                                            <i class="fa-sync-alt fa-spin fas"></i>
                                        {/if}

                                        <button class="btn btn-default mt-3 ms-3" id="taskBtn" style="border-radius: 8px; height: 42px;" onclick={() => openModal("update-vdb-modal")}>
                                            {$format("buttons.vdb")}
                                        </button>

                                        {#if !uploadingVRF}
                                        <button class="btn btn-default mt-3 ms-3" style="border-radius: 8px; height: 42px;" onclick={() => openModal("vrf-add-modal")}>
                                            {$format("buttons.vrf")}
                                        </button>
                                        {:else}
                                            <i class="fa-sync-alt fa-spin fas"></i>
                                        {/if}
                                    </div>
                                {/await}
                                {#await vulnerabilitiesPromise}
                                    <Spinner />
                                {/await}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="content mt-3">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="card">
                            {#await customVulnerabilitiesPromise then data}
                                {#key hiddenColumns}
                                    <V2List data={data} {tags} {ptOptions} {ptInstructs} on:columnsChange={columnsChange} on:tableRefresh={()=>handleTableRefresh({forceRefresh: true, resetBoxes: true})} />
                                {/key}
                            {/await}
                            {#await customVulnerabilitiesPromise}
                                <div class="card-body d-flex flex-column justify-content-center" style="min-height: 500px;">
                                    <Spinner />
                                </div>
                            {/await}
                        </div>
                    </div>
                </div>
            </div>
        </section>
        {:else}
            <section class="content-header">
                <div class="container-fluid pt-5 ps-5 pe-5 pb-5">
                    No tiene permisos para ver esta sección
                </div>
            </section>
        {/if}
    {/await}